import { render, staticRenderFns } from "./ContactsSelect.vue?vue&type=template&id=48a73aa2&"
import script from "./ContactsSelect.vue?vue&type=script&lang=js&"
export * from "./ContactsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports